import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.CREATE_MISSION:
    case actions.CREATE_THIRD_PARTY_MISSION: {
      return {
        ...state,
        isCreating: true,
      };
    }
    case actions.CREATE_MISSION_ENDED:
    case actions.CREATE_THIRD_PARTY_MISSION_ENDED: {
      return {
        ...state,
        isCreating: false,
      };
    }
    case actions.FIND_MISSION:
    case actions.FIND_SUB_MISSION_TRANSACTION_RECORD:
    case actions.FIND_MILESTONE_REWARD_TRANSACTION_RECORD:
    case actions.FIND_MISSION_TRANSACTION_RECORD:
    case actions.SEARCH_MISSIONS:
    case actions.SEARCH_MISSION_TRANSACTION_RECORD:
    case actions.SEARCH_MILESTONE_REWARD_TRANSACTION_RECORD:
    case actions.SEARCH_SUB_MISSION_TRANSACTION_RECORD:
    case actions.SEARCH_SUB_MISSION_DETAILS:
    case actions.SEARCH_MISSION_PROGRESS:
    case actions.SEARCH_MISSIONS_WITH_PROGRESS:
    case actions.SEARCH_THIRD_PARTY_SUB_MISSIONS: {
      return {
        ...state,
        isSearching: true,
      };
    }
    case actions.FIND_MISSION_ENDED:
    case actions.FIND_SUB_MISSION_TRANSACTION_RECORD_ENDED:
    case actions.FIND_MILESTONE_REWARD_TRANSACTION_RECORD_ENDED:
    case actions.FIND_MISSION_TRANSACTION_RECORD_ENDED:
    case actions.SEARCH_MISSIONS_ENDED:
    case actions.SEARCH_MILESTONE_REWARD_TRANSACTION_RECORD_ENDED:
    case actions.SEARCH_SUB_MISSION_TRANSACTION_RECORD_ENDED:
    case actions.SEARCH_MISSION_TRANSACTION_RECORD_ENDED:
    case actions.SEARCH_SUB_MISSION_DETAILS_ENDED:
    case actions.SEARCH_MISSIONS_WITH_PROGRESS_ENDED:
    case actions.SEARCH_MISSION_PROGRESS_ENDED:
    case actions.SEARCH_THIRD_PARTY_SUB_MISSIONS_ENDED: {
      return {
        ...state,
        isSearching: false,
      };
    }
    case actions.UPDATE_MISSION:
    case actions.UPDATE_THIRD_PARTY_MISSION: {
      return {
        ...state,
        isUpdating: true,
      };
    }
    case actions.UPDATE_MISSION_ENDED:
    case actions.UPDATE_THIRD_PARTY_MISSION_ENDED: {
      return {
        ...state,
        isUpdating: false,
      };
    }
    case actions.DELETE_MISSION:
    case actions.DELETE_THIRD_PARTY_MISSION: {
      return {
        ...state,
        isDeleting: true,
      };
    }
    case actions.DELETE_MISSION_ENDED:
    case actions.DELETE_THIRD_PARTY_MISSION_ENDED: {
      return {
        ...state,
        isDeleting: false,
      };
    }
    default:
      return state;
  }
};
